module.exports = __webpack_public_path__ + "media/images/fit-for-budget-342086cbd7877c7d1897be8401dc0011.svg";